import React from "react";
import "../styles/ClaimResult.css";

const SpeechEvidenceCard = ({
  bill_name,
  supporting_quote,
  tags = [],
  individual_verdict,
  individual_reasoning,
  speech_date,
  house,
  url,
}) => {
  return (
    <div className="speech-card">
      <div className="speech-card-header">
        <a href={url} target="_blank" rel="noopener noreferrer">
          <h4 className="speech-card-title">{bill_name}</h4>
        </a>
        {individual_verdict && (
          <div
            className={`verdict-pill ${
              // Directly determine and add the verdict-specific class
              individual_verdict === "valid"
                ? "verdict-pill-valid"
                : individual_verdict === "invalid"
                ? "verdict-pill-invalid"
                : "verdict-pill-ambiguous" // Fallback for 'cannot determine', 'not directly relevant', etc.
            }`}
            // data-tooltip={individual_reasoning}
          >
            {individual_verdict === "valid"
              ? `✅ Valid`
              : individual_verdict === "invalid"
              ? `❎ Invalid`
              : `❓ Ambiguous`}
          </div>
        )}
      </div>

      <p className="speech-quote">“{supporting_quote}”</p>

      <div className="speech-card-meta">
        <div className="speech-tags">
          {tags.map((tag, index) => (
            <span key={index} className="speech-tag">
              {tag}
            </span>
          ))}
        </div>
        <div className="speech-meta-info">
          <span>{house}</span> · <span>{speech_date}</span>
        </div>
      </div>
    </div>
  );
};

export default SpeechEvidenceCard;
